import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getPatientOverviewQueryKey } from "./use-get-patient-overview";
import endVisit from "../../controllers/appointments/end-visit";

const usePostEndVisit = () => {
  const queryClient = useQueryClient();

  return useMutation(endVisit, {
    onSuccess: (_, { pid }) => {
      queryClient.removeQueries(getPatientOverviewQueryKey(pid.oid));
    },
  });
};

export default usePostEndVisit;
